import React, { Component } from "react";
import styles from "./styles.module.css";

export class BtnRound extends Component {
  render() {
    const { className, onClick, data_tip, style, children } = this.props;
    return (
      <button
        onClick={onClick}
        className={`${styles.btn_round} ${className}`}
        data-tip={data_tip}
        style={style}
      >
        {children}
      </button>
    );
  }
}
